export default function getBrowser() {
    if (typeof InstallTrigger !== 'undefined') {
        return 'firefox';
    }

    if (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime)) {
        return 'chrome';
    }

    if (navigator.appVersion.indexOf("Edg/") != -1) {
        return 'edge';
    }

    if (/constructor/i.test(window.HTMLElement) || (function (p) {
        return p.toString() === "[object SafariRemoteNotification]";
    })(!window.safari || (typeof safari !== 'undefined' && window.safari.pushNotification))) {
        return 'safari';
    }

    return false;
};
